//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function create(dto: Types.ProjectSignerCreateDto, config?: AxiosRequestConfig | undefined): Promise<Types.ProjectSignerDto> {
    let url_ = getBaseUrl() + "/api/project-signers";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeProjectSignerCreateDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.ProjectSignerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initProjectSignerDto(resultData200);
        return Promise.resolve<Types.ProjectSignerDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProjectSignerDto>(null as any);
}

export function search(projectId?: number | null | undefined, projectRoleId?: number | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfProjectSignerDto> {
    let url_ = getBaseUrl() + "/api/project-signers?";
    if (projectId !== undefined && projectId !== null)
        url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
    if (projectRoleId !== undefined && projectRoleId !== null)
        url_ += "ProjectRoleId=" + encodeURIComponent("" + projectRoleId) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearch,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearch?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearch(_response);
    });
}

function processSearch(response: AxiosResponse): Promise<Types.PagedResultOfProjectSignerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPagedResultOfProjectSignerDto(resultData200);
        return Promise.resolve<Types.PagedResultOfProjectSignerDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfProjectSignerDto>(null as any);
}

export function get(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.ProjectSignerDto> {
    let url_ = getBaseUrl() + "/api/project-signers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.ProjectSignerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initProjectSignerDto(resultData200);
        return Promise.resolve<Types.ProjectSignerDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProjectSignerDto>(null as any);
}

/**
 * If the most priority signer changes, returns the list of document names, that will be invalidated.
 */
export function verifySignersUpdateAbility(dto: Types.UpdateProjectSignersDto, config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/project-signers/update-signers/verify";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateProjectSignersDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigVerifySignersUpdateAbility,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigVerifySignersUpdateAbility?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processVerifySignersUpdateAbility(_response);
    });
}

function processVerifySignersUpdateAbility(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

export function updateSigners(dto: Types.UpdateProjectSignersDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/project-signers/update-signers";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateProjectSignersDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateSigners,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigUpdateSigners?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateSigners(_response);
    });
}

function processUpdateSigners(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigSearch: Partial<AxiosRequestConfig> | null;
export function getSearchRequestConfig() {
  return _requestConfigSearch;
}
export function setSearchRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearch = value;
}
export function patchSearchRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearch = patch(_requestConfigSearch ?? {});
}

let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigVerifySignersUpdateAbility: Partial<AxiosRequestConfig> | null;
export function getVerifySignersUpdateAbilityRequestConfig() {
  return _requestConfigVerifySignersUpdateAbility;
}
export function setVerifySignersUpdateAbilityRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigVerifySignersUpdateAbility = value;
}
export function patchVerifySignersUpdateAbilityRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigVerifySignersUpdateAbility = patch(_requestConfigVerifySignersUpdateAbility ?? {});
}

let _requestConfigUpdateSigners: Partial<AxiosRequestConfig> | null;
export function getUpdateSignersRequestConfig() {
  return _requestConfigUpdateSigners;
}
export function setUpdateSignersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSigners = value;
}
export function patchUpdateSignersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSigners = patch(_requestConfigUpdateSigners ?? {});
}